import { Perfil } from "../../../models/enum";
import { useUsuario } from "../../../providers/usuarioProvider";
import PainelInvestidor from "./investidor";
import PainelContador from "./contador";
import { TourProvider } from "@reactour/tour";
import { deleteField, updateDoc } from "firebase/firestore";
import UsuarioDb from "../../../db/usuarioDb";

export default function Painel() {
  const { usuario, isLoading, claims } = useUsuario();
  if (isLoading || !!!claims?.perfil) return <></>;
  else {
    return (
      <TourProvider
        defaultOpen={false}
        steps={[]}
        beforeClose={async () => {
          if (!!usuario)
            await updateDoc(new UsuarioDb().doc({ usuarioId: usuario.id }), {
              tour: deleteField(),
            });
        }}
      >
        {claims.perfil === Perfil.INVESTIDOR ? (
          <PainelInvestidor />
        ) : (
          <PainelContador />
        )}
      </TourProvider>
    );
  }
}
